<script>

    import { timeFormat } from "d3";
    let { xScale, xTicks, chartheight=500, margin} = $props();

    // $inspect(xScale, xTicks, chartwidth)

    const classes = [-0.5, 0, 0.5]
    const classNames = ['nina', 'zero', 'nino'];

</script>

{#if xScale && xTicks && chartheight}
    {#each xTicks as tick, i}
        {@const classHad = classes.includes(tick) ? classNames[classes.indexOf(tick)] : null}
        {@const prefix = tick > 0 ? '+' : ''}
        {@const suffix = i === xTicks.length - 1 ? '°C' : ''}
        <line x1={xScale(tick)} x2={xScale(tick)} y2={chartheight} y1=-10 stroke-width=1 class={classHad}></line>
        <text x={xScale(tick)} y=-15 class="tick-text">{prefix}{tick}{suffix}</text>
    {/each}
{/if}

<style lang='scss'>
    line {
        stroke: $gray2;
        stroke-width: 1;
        &.zero {
            stroke: $gray7;
            stroke-width: 1.5;
        }
        &.nino {
            stroke: $nino-floor;
            stroke-width: 2;
        }
        &.nina {
            stroke: $nina-ceil;
            stroke-width: 2;
        }
    }
    .tick-text {
        fill: #999;
        font-size: 11px;
        text-anchor: middle;  
    }
</style>